import { createRoot } from 'react-dom/client';
import React, { useEffect, useRef, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { Document, Page, pdfjs } from 'react-pdf';
import { PDFViewerProps } from './contracts';

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();

export const PDFViewer: React.FC<PDFViewerProps> = ({ fileUrl }) => {
	const ref = useRef<HTMLDivElement>(null);
	const [numPages, setNumPages] = useState<number>();
	const [pageNumber, setPageNumber] = useState<number>();
	const [availableWidth, setAvailableWidth] = useState<number>(window.screen.availWidth <= 767 ? window.screen.availWidth : undefined);

	useEffect(() => {
		const resizeHandler = () => {
			if (window.screen.availWidth <= 767) {
				setAvailableWidth(window.screen.availWidth);
			} else {
				setAvailableWidth(ref.current.offsetWidth);
			}
		};

		window.addEventListener('resize', resizeHandler);
		if (availableWidth === undefined) {
			setAvailableWidth(ref.current.offsetWidth);
		}
		return () => {
			window.removeEventListener('resize', resizeHandler);
		};
	}, []);

	return (
		<div ref={ref} style={{ margin: '0 auto' }}>
			<Document
				file={fileUrl}
				onLoadSuccess={({ numPages }) => {
					setNumPages(numPages);
					setPageNumber(1);
				}}
			>
				<Page
					pageNumber={pageNumber}
					width={availableWidth}
					renderMode="canvas"
					renderAnnotationLayer={false}
					renderTextLayer={false}
				/>
			</Document>
			{numPages > 1 ? (
				<div className="umb-paginate" id="react-paginate">
					<ReactPaginate
						previousLabel={'<'}
						nextLabel={'>'}
						breakLabel={<a href="#">...</a>}
						breakClassName={'break-me'}
						pageCount={numPages}
						marginPagesDisplayed={1}
						pageRangeDisplayed={1}
						onPageChange={dat => {
							setPageNumber(dat.selected + 1);
						}}
						containerClassName="pagination"
						activeClassName="active"
					/>
				</div>
			) : null}
		</div>
	);
};

export function MountPDFViewer(props: any, el: Element) {
	const root = createRoot(el);
	root.render(<PDFViewer {...props} />);
}
